import MotorParseable from "./class.MotorParseable";

export default class BarGraph extends MotorParseable {
	isClearButtonEnabled() {
		return this.clearButtonIsEnabled;
	}

	constructor(options) {
		super(options);
		this.clearButtonIsEnabled = false;
		this.startingValues = [];
	}

	getNewDriver() {
		return new Motors.Drivers.BarGraphDriver();
	}

	getStartSignal() {
		this.startingValues = this.tryJSONParse(this.model.values) || [];

		return {
			width: this.model.width,
			height: this.model.height,
			bottom: this.model.bottom,
			top: this.model.top,
			tickStep: this.model.tickStep,
			interaction: this.model.interaction,
			orientation: this.model.orientation,
			barLabels: this.tryJSONParse(this.model.barLabels),
			barColors: this.tryJSONParse(this.model.barColors),
			barAccuracy: this.model.barAccuracy,
			values: this.driverOutputs["values"] || this.startingValues,
			barStates: this.driverOutputs["barStates"] || [],
			selectedIndices: this.driverOutputs["selectedIndices"] || [],
			title: this.model.title,
			xLabel: this.model.xLabel,
			yLabel: this.model.yLabel,
		};
	}

	getCachedResponseSignal(data) {
		const signal = {};
		if (data.values) {
			signal.values = data.values;
		}
		if (data.selectedIndices) {
			signal.selectedIndices = data.selectedIndices;
		}
		return signal;
	}

	onRenderResponse($responseDiv) {
		this.clearButtonIsEnabled = this.isChangedState();
		this.rerenderClearButton();

		this.setSubmittable(this.isResponseSubmittable());

		const preview = this.driverOutputs[this.previewKey] || [];

		if (this.previewKey === "noPreview") {
			return;
		} else if (preview.length === 0) {
			$responseDiv.html("<em>None selected.</em>");
		} else {
			$responseDiv.text(preview.join(", "));
		}
	}

	isResponseSubmittable() {
		const response = this.driverOutputs[this.answerKey];
		if (response === undefined) {
			return false;
		}

		if (this.model.interaction === "build") {
			return this.driverOutputs["barStates"].every((b) => {
				return b === 2;
			});
		}

		if (Array.isArray(response)) {
			return response.length !== 0;
		} else {
			console.error("response has unexpected format");
		}
	}

	/**
	 * Whether the current state is not the same as the initial state.
	 */
	isChangedState() {
		if (this.model.interaction === "build") {
			return (
				this.driverOutputs["values"].findIndex((v, i) => {
					return (this.startingValues[i] ? this.startingValues[i] : 0) !== v;
				}) > -1
			);
		} else {
			return this.driverOutputs["selectedIndices"].length > 0;
		}
	}
}
